import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import "./Review_contract_table.css";
import Certification_Modal from "../../../../../../../common/common_modal/certification_modal/Certification_Modal";
import Pagination_Holder from "../../../../../../../common/common_components/pagination_holder/Pagination_Holder";
import { faEye, faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import Image_Show_Modal from "../../../../../../../common/common_modal/image_show_modal/image_show_modal";
import Delete_Modal from "../../../../../../../common/common_modal/delete_model/Delete_Modal";
import {
  Delete,
  GetAll,
} from "../../../../../../../features/admin/quality_management/process_requirement/tender/Slice";
import { useDispatch, useSelector } from "react-redux";
import { formatDate } from "../../../../../../../utils/common";
import { FixIDS } from "../../../../../../../utils/fixIDS";

function Review_contract_table({
  all_customer_details,
  currentPage,
  setCurrentPage,
  onEdit,
}) {
  const [showModal, setModal] = useState(false);
  const totalPages = all_customer_details?.total_pages || 1;
  const [show, setShow] = useState(false);

   const [showNote, setShowNote] = useState(false);

  const [showData, setShowData] = useState("");
  const dispatch = useDispatch();
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const openDeleteModal = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!deleteId) return;

    try {
      await dispatch(Delete(deleteId));
      setShowDeleteModal(false);
      dispatch(
        GetAll({
          page: currentPage,
          per_page: all_customer_details.per_page,
        }),
      );
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const permissions = useSelector((state) => state.auth.permissions);

  const haveDeletePermission = permissions?.includes(
    FixIDS.review_of_request.Delete,
  );
  const haveEditPermission = permissions?.includes(
    FixIDS.review_of_request.Edit,
  );
  const haveViewPermission = permissions?.includes(
    FixIDS.review_of_request.View,
  );

  return (
    <>
      <section className="Imperiality_table">
        <div className="common_table_container theme_bg">
          <div className="table-responsive">
            <table className="common_table table table-striped customer_table">
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>Date</th>
                  <th>Name Of Tender</th>
                  <th>Material</th>
                  <th>Approval Note</th>
                  <th>Remark</th>
                  <th>Tendor Document</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {all_customer_details?.data.length > 0 ? (
                  all_customer_details?.data?.map((row, index) => (
                    <tr key={row.id || index}>
                      <td>
                        {(currentPage - 1) *
                          (all_customer_details?.per_page ||
                            all_customer_details?.data?.length ||
                            0) +
                          index +
                          1}
                      </td>
                      <td>{formatDate(row?.createdAt)}</td>
                      <td>{row.name_of_tender || "-"}</td>

                      <td>{row.material || "-"}</td>
                      <td>
                        <div
                          className="action_icons"
                          onClick={() => {
                            setShowNote(true);
                            setShowData(row);
                          }}
                        >
                          {haveViewPermission && (
                            <FontAwesomeIcon icon={faEye} />
                          )}
                        </div>
                      </td>
                      {/* <td>{row.approval_note || "-"}</td> */}
                      <td>{row.remark || "-"}</td>

                      <td>
                        <div
                          className="action_icons"
                          onClick={() => {
                            setShow(true);
                            setShowData(row);
                          }}
                        >
                          {haveViewPermission && (
                            <FontAwesomeIcon icon={faEye} />
                          )}
                        </div>
                      </td>

                      <td>
                        <div className="action_icons">
                          {haveEditPermission && (
                            <FontAwesomeIcon
                              icon={faPen}
                              onClick={() => onEdit(row.id)}
                              style={{ cursor: "pointer" }}
                            />
                          )}

                          {haveDeletePermission && (
                            <FontAwesomeIcon
                              icon={faTrash}
                              onClick={() => openDeleteModal(row?.id)}
                              style={{ cursor: "pointer" }}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center">
                      Data not available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">
            Showing {all_customer_details?.data?.length} of{" "}
            {all_customer_details?.total || 0} Entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={handlePageChange}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>

      <Certification_Modal
        show={showModal}
        onHide={() => setModal(false)}
        modalHeadingText={"Review Of Request , Tenders & Contract"}
        imgSrc={"/assets/images/cerificate/certi.png"}
        btnText={"Download"}
      />
      <Image_Show_Modal
        onHide={() => setShow(false)}
        show={show}
        showData={showData}
        imgSrc={process.env.REACT_APP_IMG_URL + showData?.tendor_document}
      />

        <Image_Show_Modal
        onHide={() => setShowNote(false)}
        show={showNote}
        showData={showData}
        imgSrc={process.env.REACT_APP_IMG_URL + showData?.approval_note}
      />
      <Delete_Modal
        onHide={() => setShowDeleteModal(false)}
        show={showDeleteModal}
        confirmDelete={confirmDelete}
      />
    </>
  );
}

export default Review_contract_table;
